import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '../../lib/utils';
import type {
  TabsContentProps,
  TabsListProps,
  TabsTriggerProps,
  TabsWrapperProps,
} from './types';

const Tabs = TabsPrimitive.Root;

Tabs.displayName = TabsPrimitive.Root.displayName;

const TabsList = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.List>,
  TabsListProps
>(({ className, ...props }, ref) => {
  return (
    <div className='eye:overflow-x-auto eye:scroll-smooth'>
      <TabsPrimitive.List
        ref={ref}
        className={cn(
          'eye:inline-flex eye:items-center eye:rounded-lg eye:bg-grey-20',
          className,
        )}
        {...props}
      />
    </div>
  );
});

TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.Trigger>,
  TabsTriggerProps
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'eye:body-s eye:inline-flex eye:cursor-pointer eye:items-center eye:justify-center eye:rounded-lg eye:px-2xs eye:py-3xs eye:whitespace-nowrap eye:transition-all eye:hover:bg-lightgrey-hover eye:focus-visible:outline-2 eye:focus-visible:outline-offset-2 eye:focus-visible:outline-black eye:disabled:pointer-events-none eye:disabled:opacity-50 eye:data-[state=active]:m-5xs eye:data-[state=active]:bg-white eye:data-[state=active]:px-3xs eye:data-[state=active]:py-4xs eye:data-[state=active]:font-semibold',
      className,
    )}
    {...props}
  />
));

TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ComponentRef<typeof TabsPrimitive.Content>,
  TabsContentProps
>(({ ...props }, ref) => <TabsPrimitive.Content ref={ref} {...props} />);

TabsContent.displayName = TabsPrimitive.Content.displayName;

const TabsWrapper = React.forwardRef<
  React.ElementRef<typeof Tabs>,
  TabsWrapperProps
>(({ tabs, tabPanelProps, children, ...props }, ref) => {
  return (
    <Tabs ref={ref} {...props}>
      {children}

      {tabs.map((tab, index) => (
        <TabsContent
          key={tab.key || index}
          value={String(index)}
          {...tabPanelProps}
        >
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
});

TabsWrapper.displayName = 'TabsWrapper';

export { Tabs, TabsList, TabsTrigger, TabsContent, TabsWrapper };
